import React from 'react';
import { GridColumnMenuFilterUIProps } from '@progress/kendo-react-grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';

export const NumericColumnMenuFilter = (props: GridColumnMenuFilterUIProps) => {
  return (
    <div className="k-filter-menu-container">
      <DropDownList
        data={props.firstFilterProps.operators}
        textField="text"
        dataItemKey="operator"
        value={props.firstFilterProps.operators.find(o => o.operator === props.firstFilterProps.operator) || null}
        onChange={e =>
          props.firstFilterProps.onChange({
            value: props.firstFilterProps.value,
            operator: e.value.operator,
            syntheticEvent: e.syntheticEvent
          })
        }
      />

      <NumericTextBox
        value={props.firstFilterProps.value || null}
        format={{ useGrouping: false }}
        onChange={e =>
          props.firstFilterProps.onChange({
            value: e.value,
            operator: props.firstFilterProps.operator || 'eq',
            syntheticEvent: e.syntheticEvent
          })
        }
      />
    </div>
  );
};
